var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#FF6DB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0765 26L39.0215 30.2C37.553 33.2005 35.585 35.9294 33.2015 38.27L32.9315 38.525C31.4007 40.0111 30.526 42.0466 30.5015 44.18V44.45C30.4609 48.6277 32.9504 52.4152 36.8015 54.035L37.1915 54.2C39.7173 55.2728 42.5707 55.2728 45.0965 54.2H45.1865C49.0663 52.5143 51.5557 48.6649 51.5015 44.435V37.925C50.2085 40.8778 47.8604 43.242 44.9165 44.555C44.9165 44.555 44.9165 44.555 44.8265 44.555C44.7365 44.555 43.6865 44.99 43.2365 44.555C42.8345 44.1483 42.796 43.5068 43.1465 43.055L43.2515 42.98H43.3265C46.7701 40.3625 47.5729 35.5126 45.1565 31.925C43.2065 28.955 41.0765 26 41.0765 26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.60a13736cf0d787890e35a00cfe8d64c.svg";
export { ForwardRef as ReactComponent };